module.exports = __webpack_public_path__ + "static/media/AbhishekUppeResume.70118be2.pdf";